import { SERVICE_NAME } from '@shared/constants/service'
import { Link } from '@tanstack/react-router'

const BUSINESS_INFO = {
  companyName: '초코모카팩토리',
  registrationNumber: '774-65-00435',
  representative: '오경남',
  address: '서울특별시 마포구 잔다리로6길 20-6, 1동 2층 203호',
  phone: '02-6080-8264',
} as const

export function Footer() {
  return (
    <footer className="border-t border-white/[0.06] bg-bg-deep px-page-x py-6">
      <div className="flex gap-3 typo-footnote">
        <Link to="/terms" className="text-muted-foreground underline-offset-2 hover:underline">
          이용약관
        </Link>
        <Link to="/privacy" className="text-muted-foreground underline-offset-2 hover:underline">
          개인정보처리방침
        </Link>
      </div>

      <dl className="mt-4 grid grid-cols-[auto_1fr] gap-x-3 gap-y-1 typo-footnote text-muted-foreground/60">
        <dt>상호명</dt>
        <dd>{BUSINESS_INFO.companyName}</dd>

        <dt>대표자</dt>
        <dd>{BUSINESS_INFO.representative}</dd>

        <dt>사업자등록번호</dt>
        <dd>{BUSINESS_INFO.registrationNumber}</dd>

        <dt>주소</dt>
        <dd>{BUSINESS_INFO.address}</dd>

        <dt>연락처</dt>
        <dd>{BUSINESS_INFO.phone}</dd>
      </dl>

      <p className="mt-4 typo-footnote text-muted-foreground/40">
        &copy; {new Date().getFullYear()} {SERVICE_NAME}. All rights reserved.
      </p>
    </footer>
  )
}
